import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

const StyledAssessmentInfoBlocks = styled(NanoFlex)`
  gap: 24px;
  padding: 0 100px 0 100px;

  .blockNumber {
    color: ${(props) => props.theme.color.primaryColors.white};
    font-weight: normal;
  }

  .infoBlock {
    flex: 1 calc(33.33% - 24px);
    width: calc(33.33% - 24px);
    min-height: 350px;
    height: auto;
    background-color: ${(props) => props.theme.color.primaryColors.yellow};
    border-radius: 10px;
    padding: 32px;
    gap: 24px;

    @media only screen and (max-width: 1450px) {
      min-height: 308px;
      height: auto;
    }

    @media only screen and (max-width: 1024px) {
      flex: 1 100%;
      width: 100%;
      min-height: unset;
      min-height: 352px;
    }

    .iconWrap {
      height: auto;
      svg {
        height: 36px;
        width: auto;
      }
    }

    .titleWrap {
      h5 {
        text-transform: none;
        font-weight: 600;
      }
    }

    .contentWrap {
      flex-grow: 1;

      p {
        color: ${(props) => props.theme.color.primaryColors.darkPurple};
      }
    }
  }

  @media only screen and (max-width: 1450px) {
    padding: 0 50px 0 50px;
  }
  @media only screen and (max-width: 1024px) {
    padding: 0 30px 0 30px;
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    padding: 0 10px 0 10px;
    gap: 16px;
    flex-wrap: wrap;

    .infoBlock {
      border-radius: 5px;
      padding: 16px;
      min-height: 215px;

      &:first-child {
        width: auto;
        flex: 1 calc(50% - 16px);
      }
      &:nth-child(2) {
        width: auto;
        flex: 1 calc(50% - 16px);
      }

      &:last-child {
        width: 100%;
        flex: 1 100%;
        min-height: auto;
      }
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    flex-direction: column;
    flex-wrap: nowrap;

    .infoBlock {
      min-height: unset;
      height: auto;
    }
  }
`;

export default class AssessmentInfoBlocks extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAssessmentInfoBlocks alignItems={"flex-start"}>
        <NanoFlex className="infoBlock" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex className="titleWrap" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
            <Type.h5 className="blockNumber">01.</Type.h5>
            <Type.h5>{this.translation.assessment.consciousDecision}</Type.h5>
          </NanoFlex>
          <NanoFlex className="contentWrap" alignItems="flex-end" justifyContent="flex-start">
            <Type.p>{this.translation.assessment.blockArticleOne}</Type.p>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="infoBlock" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex className="titleWrap" flexDirection="column" a alignItems="flex-start" justifyContent="flex-start">
            <Type.h5 className="blockNumber">02.</Type.h5>
            <Type.h5>{this.translation.assessment.behavioralProfile}</Type.h5>
          </NanoFlex>
          <NanoFlex className="contentWrap" alignItems="flex-end" justifyContent="flex-start">
            <Type.p>{this.translation.assessment.blockArticleTwo}</Type.p>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="infoBlock" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex className="titleWrap" flexDirection="column" a alignItems="flex-start" justifyContent="flex-start">
            <Type.h5 className="blockNumber">03.</Type.h5>
            <Type.h5>{this.translation.assessment.professionalAndPersonalDevelopent}</Type.h5>
          </NanoFlex>
          <NanoFlex className="contentWrap" alignItems="flex-end" justifyContent="flex-start">
            <Type.p>{this.translation.assessment.blockArticleThree}</Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledAssessmentInfoBlocks>
    );
  }
}
